module.exports = {
  colorYellowBase: "#FAAC11",
  colorBlack8: "rgba(39, 44, 53, 0.2)",
  colorGreen4: "#ABE5D8",
  colorBlack9: "rgba(39, 44, 53, 0.1)",
  colorGreen5: "#CAEFE7",
  colorYellow1: "#FAB834",
  colorGreen6: "#EAF8F5",
  colorYellow2: "#FBC558",
  colorWhite1: "rgba(255, 255, 255, 0.9)",
  colorYellow3: "#FCD17C",
  colorWhite2: "rgba(255, 255, 255, 0.8)",
  colorGreenBase: "#2DBD9D",
  colorYellow4: "#FDDD9F",
  colorWhite3: "rgba(255, 255, 255, 0.7)",
  colorYellow5: "#FDEAC3",
  colorWhite4: "rgba(255, 255, 255, 0.6)",
  colorYellow6: "#FFF7E7",
  colorWhite5: "rgba(255, 255, 255, 0.5)",
  colorBlue1: "#3482EA",
  colorWhite6: "rgba(255, 255, 255, 0.4)",
  colorBlue2: "#5998EE",
  colorWhite7: "rgba(255, 255, 255, 0.3)",
  colorBlue3: "#7CAEF1",
  colorPurple1: "#9245BD",
  colorWhite8: "rgba(255, 255, 255, 0.2)",
  colorBlue4: "#A0C5F5",
  colorPurple2: "#A566C9",
  colorRed1: "#E33D66",
  colorWhite9: "rgba(255, 255, 255, 0.1)",
  colorBlue5: "#C2DAF9",
  colorPurple3: "#B887D4",
  colorRed2: "#E85F81",
  colorBlue6: "#E7F1FD",
  colorPurple4: "#CBA7E0",
  colorRed3: "#ED829C",
  colorPurple5: "#DEC8EB",
  colorRed4: "#F2A4B7",
  colorPurple6: "#F2E9F7",
  colorRed5: "#F7C6D2",
  colorRed6: "#FCE8ED",
  colorGray1: "#272C35",
  colorGray2: "#646F85",
  colorGray3: "#B9BFCB",
  colorGray4: "#DDE0E6",
  colorGray5: "#F0F1F5",
  colorGray6: "#F7F7F9",
  colorRedBase: "#DE1B4B",
  colorSolidBlack1: "#40444D",
  colorPurpleBase: "#7F25B2",
  colorSolidBlack2: "#595C63",
  colorBlack1: "rgba(39, 44, 53, 0.9)",
  colorSolidBlack3: "#6F7278",
  colorBlack2: "rgba(39, 44, 53, 0.8)",
  colorBlueBase: "#176EE1",
  colorFauxBlack: "#040405",
  colorSolidBlack4: "#86888D",
  colorBlack3: "rgba(39, 44, 53, 0.7)",
  colorSolidBlack5: "#9C9EA1",
  colorBlack4: "rgba(39, 44, 53, 0.6)",
  colorSolidBlack6: "#B0B2B4",
  colorBlack5: "rgba(39, 44, 53, 0.5)",
  colorGreen1: "#4CC7AC",
  colorSolidBlack7: "#C5C5C7",
  colorBlack6: "rgba(39, 44, 53, 0.4)",
  colorGreen2: "#6CD1BA",
  colorSolidBlack8: "#D8D9DB",
  colorWhite: "#FFFFFF",
  colorBlack7: "rgba(39, 44, 53, 0.3)",
  colorGreen3: "#8BDBC9",
  colorSolidBlack9: "#ECECEC",
};